class AppliedMeasureCounts {
  constructor(stats = {}) {
    this.count = stats.count;
    this.children_count = stats.children_count;
  }
}

export default AppliedMeasureCounts;
